import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  Components.addType("about-us", {
    model: {
      defaults: {
        components: html`
          <section class="w-full my-4 bg-black/50">
            <div class="relative z-10 border-gray-500 " id="counter-section">
              <div
                class="container md:mx-auto md:grid md:grid-cols-2 w-full h-full grid grid-cols-1 items-center px-6 py-12 md:px-16 md:py-20 gap-6"
              >
                <div class="flex flex-col justify-center">
                  <div class="">
                    <div class="flex items-center leading-2.5 gap-1 my-2">
                      <div
                        class="bg-amber-600 w-1 md:h-12 h-6 inline-block"
                      ></div>
                      <h3
                        class="md:text-4xl text-lg font-bold font-roboto tracking-normal text-[#0083D7]"
                      >
                        About Us
                      </h3>
                    </div>
                    <h3
                      class="text-xl text-white font-roboto tracking-normal md:text-2xl text-nowrap"
                    >
                      A Delivery and Transport Company
                    </h3>
                    <div class="flex mt-[13px] gap-1">
                      <p
                        class="text-[#FA6914] font-roboto tracking-normal text-2xl"
                      >
                        17+
                      </p>
                      <div class="w-[3px] bg-amber-600 inline-block"></div>
                      <span
                        class="text-white font-roboto tracking-normal text-xl md:text-2xl"
                        >Years of Experience</span
                      >
                    </div>

                    <div class="flex gap-3 mt-4">
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 2.66675C9.16663 2.66675 3.16663 8.66675 3.16663 16.0001C3.16663 23.3334 9.16663 29.3334 16.5 29.3334C23.8333 29.3334 29.8333 23.3334 29.8333 16.0001C29.8333 8.66675 23.8333 2.66675 16.5 2.66675ZM13.8333 22.6667L7.16663 16.0001L9.04663 14.1201L13.8333 18.8934L23.9533 8.77341L25.8333 10.6667L13.8333 22.6667Z"
                          fill="#FEFEFE"
                        />
                      </svg>

                      <p
                        class="font-roboto tracking-normal text-xl md:text-2xl text-white"
                      >
                        17+ Years
                      </p>
                    </div>
                    <div class="flex gap-3 mt-4">
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 2.66675C9.16663 2.66675 3.16663 8.66675 3.16663 16.0001C3.16663 23.3334 9.16663 29.3334 16.5 29.3334C23.8333 29.3334 29.8333 23.3334 29.8333 16.0001C29.8333 8.66675 23.8333 2.66675 16.5 2.66675ZM13.8333 22.6667L7.16663 16.0001L9.04663 14.1201L13.8333 18.8934L23.9533 8.77341L25.8333 10.6667L13.8333 22.6667Z"
                          fill="#FEFEFE"
                        />
                      </svg>
                      <p
                        class="text-white font-roboto tracking-normal text-xl md:text-2xl"
                      >
                        Worldwide Shipping
                      </p>
                    </div>
                    <div class="flex gap-3 mt-4">
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 2.66675C9.16663 2.66675 3.16663 8.66675 3.16663 16.0001C3.16663 23.3334 9.16663 29.3334 16.5 29.3334C23.8333 29.3334 29.8333 23.3334 29.8333 16.0001C29.8333 8.66675 23.8333 2.66675 16.5 2.66675ZM13.8333 22.6667L7.16663 16.0001L9.04663 14.1201L13.8333 18.8934L23.9533 8.77341L25.8333 10.6667L13.8333 22.6667Z"
                          fill="#FEFEFE"
                        />
                      </svg>
                      <p
                        class="text-white font-roboto tracking-normal text-xl md:text-2xl"
                      >
                        Air, Land & Sea Freight
                      </p>
                    </div>
                    <div class="flex gap-3 mt-4">
                      <svg
                        width="33"
                        height="32"
                        viewBox="0 0 33 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M16.5 2.66675C9.16663 2.66675 3.16663 8.66675 3.16663 16.0001C3.16663 23.3334 9.16663 29.3334 16.5 29.3334C23.8333 29.3334 29.8333 23.3334 29.8333 16.0001C29.8333 8.66675 23.8333 2.66675 16.5 2.66675ZM13.8333 22.6667L7.16663 16.0001L9.04663 14.1201L13.8333 18.8934L23.9533 8.77341L25.8333 10.6667L13.8333 22.6667Z"
                          fill="#FEFEFE"
                        />
                      </svg>
                      <p
                        class="text-white font-roboto tracking-normal text-xl md:text-2xl"
                      >
                        On-Time Delivery
                      </p>
                    </div>
                  </div>
                </div>

                <div
                  class="grid grid-cols-2 justify-center items-center text-center w-full rounded-md overflow-hidden"
                >
                  <div
                    class="bg-[#FA6914] flex flex-col justify-center items-center text-center md:py-8 py-6"
                  >
                    <svg
                      width="51"
                      height="50"
                      viewBox="0 0 51 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75 43.75V39.5833C6.75 37.3732 7.62797 35.2536 9.19078 33.6908C10.7536 32.128 12.8732 31.25 15.0833 31.25H23.4167C25.6268 31.25 27.7464 32.128 29.3092 33.6908C30.872 35.2536 31.75 37.3732 31.75 39.5833V43.75M33.8333 6.52083C35.6259 6.97979 37.2147 8.02229 38.3492 9.48398C39.4838 10.9457 40.0997 12.7434 40.0997 14.5937C40.0997 16.4441 39.4838 18.2418 38.3492 19.7035C37.2147 21.1652 35.6259 22.2077 33.8333 22.6667M44.25 43.75V39.5833C44.2394 37.7441 43.6207 35.96 42.4901 34.5092C41.3596 33.0583 39.7809 32.0223 38 31.5625M10.9167 14.5833C10.9167 16.7935 11.7946 18.9131 13.3574 20.4759C14.9202 22.0387 17.0399 22.9167 19.25 22.9167C21.4601 22.9167 23.5798 22.0387 25.1426 20.4759C26.7054 18.9131 27.5833 16.7935 27.5833 14.5833C27.5833 12.3732 26.7054 10.2536 25.1426 8.69078C23.5798 7.12797 21.4601 6.25 19.25 6.25C17.0399 6.25 14.9202 7.12797 13.3574 8.69078C11.7946 10.2536 10.9167 12.3732 10.9167 14.5833Z"
                        stroke="#0083D7"
                        stroke-width="4.39321"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p
                      id="year-count"
                      class="font-roboto text-white font-bold md:text-2xl text-sm"
                    >
                      17
                    </p>

                    <p class="font-roboto text-[#0083D7] md:text-2xl text-sm">
                      Year Experience
                    </p>
                  </div>

                  <div
                    class="bg-[#0083D7] flex flex-col justify-center items-center text-center md:py-8 py-6"
                  >
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.25 43.75V39.5833C6.25 37.3732 7.12797 35.2536 8.69078 33.6908C10.2536 32.128 12.3732 31.25 14.5833 31.25H22.9167C25.1268 31.25 27.2464 32.128 28.8092 33.6908C30.372 35.2536 31.25 37.3732 31.25 39.5833V43.75M33.3333 6.52083C35.1259 6.97979 36.7147 8.02229 37.8492 9.48398C38.9838 10.9457 39.5997 12.7434 39.5997 14.5938C39.5997 16.4441 38.9838 18.2418 37.8492 19.7035C36.7147 21.1652 35.1259 22.2077 33.3333 22.6667M43.75 43.75V39.5833C43.7394 37.7441 43.1207 35.96 41.9901 34.5092C40.8596 33.0583 39.2809 32.0223 37.5 31.5625M10.4167 14.5833C10.4167 16.7935 11.2946 18.9131 12.8574 20.4759C14.4202 22.0387 16.5399 22.9167 18.75 22.9167C20.9601 22.9167 23.0798 22.0387 24.6426 20.4759C26.2054 18.9131 27.0833 16.7935 27.0833 14.5833C27.0833 12.3732 26.2054 10.2536 24.6426 8.69078C23.0798 7.12797 20.9601 6.25 18.75 6.25C16.5399 6.25 14.4202 7.12797 12.8574 8.69078C11.2946 10.2536 10.4167 12.3732 10.4167 14.5833Z"
                        stroke="#FA6914"
                        stroke-width="4.39321"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p
                      id="staff-count"
                      class="font-roboto font-bold text-white md:text-2xl text-sm"
                    >
                      30
                    </p>

                    <p class="font-roboto text-[#FA6914] text-sm md:text-2xl">
                      Company Staffs
                    </p>
                  </div>

                  <div
                    class="bg-[#0083D7] flex flex-col justify-center items-center text-center md:py-8 py-6"
                  >
                    <svg
                      width="50"
                      height="50"
                      viewBox="0 0 50 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.25 43.75V39.5833C6.25 37.3732 7.12797 35.2536 8.69078 33.6908C10.2536 32.128 12.3732 31.25 14.5833 31.25H22.9167C25.1268 31.25 27.2464 32.128 28.8092 33.6908C30.372 35.2536 31.25 37.3732 31.25 39.5833V43.75M33.3333 6.52083C35.1259 6.97979 36.7147 8.02229 37.8492 9.48398C38.9838 10.9457 39.5997 12.7434 39.5997 14.5938C39.5997 16.4441 38.9838 18.2418 37.8492 19.7035C36.7147 21.1652 35.1259 22.2077 33.3333 22.6667M43.75 43.75V39.5833C43.7394 37.7441 43.1207 35.96 41.9901 34.5092C40.8596 33.0583 39.2809 32.0223 37.5 31.5625M10.4167 14.5833C10.4167 16.7935 11.2946 18.9131 12.8574 20.4759C14.4202 22.0387 16.5399 22.9167 18.75 22.9167C20.9601 22.9167 23.0798 22.0387 24.6426 20.4759C26.2054 18.9131 27.0833 16.7935 27.0833 14.5833C27.0833 12.3732 26.2054 10.2536 24.6426 8.69078C23.0798 7.12797 20.9601 6.25 18.75 6.25C16.5399 6.25 14.4202 7.12797 12.8574 8.69078C11.2946 10.2536 10.4167 12.3732 10.4167 14.5833Z"
                        stroke="#FA6914"
                        stroke-width="4.39321"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>

                    <p
                      id="project-count"
                      class="font-roboto font-bold text-white md:text-2xl text-sm"
                    >
                      3000
                    </p>

                    <p class="font-roboto text-[#FA6914] text-sm md:text-2xl">
                      Project Delivery
                    </p>
                  </div>

                  <div
                    class="bg-[#FA6914] md:py-8 py-6 flex flex-col justify-center items-center text-center"
                  >
                    <svg
                      width="51"
                      height="50"
                      viewBox="0 0 51 50"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75 43.75V39.5833C6.75 37.3732 7.62797 35.2536 9.19078 33.6908C10.7536 32.128 12.8732 31.25 15.0833 31.25H23.4167C25.6268 31.25 27.7464 32.128 29.3092 33.6908C30.872 35.2536 31.75 37.3732 31.75 39.5833V43.75M33.8333 6.52083C35.6259 6.97979 37.2147 8.02229 38.3492 9.48398C39.4838 10.9457 40.0997 12.7434 40.0997 14.5937C40.0997 16.4441 39.4838 18.2418 38.3492 19.7035C37.2147 21.1652 35.6259 22.2077 33.8333 22.6667M44.25 43.75V39.5833C44.2394 37.7441 43.6207 35.96 42.4901 34.5092C41.3596 33.0583 39.7809 32.0223 38 31.5625M10.9167 14.5833C10.9167 16.7935 11.7946 18.9131 13.3574 20.4759C14.9202 22.0387 17.0399 22.9167 19.25 22.9167C21.4601 22.9167 23.5798 22.0387 25.1426 20.4759C26.7054 18.9131 27.5833 16.7935 27.5833 14.5833C27.5833 12.3732 26.7054 10.2536 25.1426 8.69078C23.5798 7.12797 21.4601 6.25 19.25 6.25C17.0399 6.25 14.9202 7.12797 13.3574 8.69078C11.7946 10.2536 10.9167 12.3732 10.9167 14.5833Z"
                        stroke="#0083D7"
                        stroke-width="4.39321"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p
                      id="client-count"
                      class="font-roboto font-bold text-white md:text-2xl text-sm"
                    >
                      1000
                    </p>
                    <p class="font-roboto text-[#0083D7] text-sm md:text-2xl">
                      Satisfied Clients
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        `,
        script: function () {
          function animateCount(id, target, duration) {
            let count = 0;
            const el = document.getElementById(id);
            const interval = 30;
            const increment = Math.ceil(target / (duration / interval));

            const counter = setInterval(() => {
              count += increment;
              if (count >= target) {
                count = target;
                clearInterval(counter);
              }
              el.textContent = count.toLocaleString();
            }, interval);
          }

          let hasAnimated = false;

          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting && !hasAnimated) {
                  animateCount("staff-count", 30, 1000);
                  animateCount("project-count", 3000, 1500);
                  animateCount("year-count", 17, 1500);
                  animateCount("client-count", 1000, 1500);
                  hasAnimated = true;
                }
              });
            },
            { threshold: 0.5 }
          );

          observer.observe(document.getElementById("counter-section"));
        },
      },
    },
  });
};
